export default function getMaskText(value = '', mask, withFullMask) {
  const diff = value.length - mask.length;

  if (!withFullMask && diff >= 0) {
    return '';
  }

  return value + mask.substr(diff);
}
